/**
 * wishlistManager — Gestione globale dei toggle wishlist su tutte le pagine.
 *
 * Usa event delegation per intercettare click su `.ik-wishlist-toggle`
 * e sincronizza lo stato visivo con lo store.
 *
 * Uso nel layout:
 *   <div x-data="wishlistManager"></div>
 */
export function registerWishlistManager(Alpine) {
    Alpine.data('wishlistManager', () => ({
        init() {
            // Registra gli ID dei corsi già in wishlist (da SSR: data-in-wishlist)
            document.querySelectorAll('.ik-wishlist-toggle[data-in-wishlist]').forEach(btn => {
                const courseId = parseInt(btn.dataset.courseId, 10);
                if (courseId) {
                    this.$store.wishlist.trackId(courseId);
                }
            });

            // Event delegation per click sui toggle
            document.addEventListener('click', (e) => {
                const btn = e.target.closest('.ik-wishlist-toggle');
                if (!btn) return;

                e.preventDefault();
                e.stopPropagation();

                const courseId = parseInt(btn.dataset.courseId, 10);
                if (!courseId) return;

                // Optimistic UI: toggle classe immediatamente
                const isActive = btn.classList.contains('ik-wishlist-toggle--active');
                btn.classList.toggle('ik-wishlist-toggle--active', !isActive);

                // Aggiorna aria-label
                btn.setAttribute('aria-label',
                    isActive ? 'Aggiungi alla wishlist' : 'Rimuovi dalla wishlist'
                );

                // Toggle nello store (gestisce API + rollback)
                this.$store.wishlist.toggle(courseId).then(added => {
                    // Sincronizza tutti i toggle con lo stesso course ID
                    // (es. card nel catalogo + card nei correlati)
                    document.querySelectorAll(`.ik-wishlist-toggle[data-course-id="${courseId}"]`).forEach(otherBtn => {
                        if (otherBtn !== btn) {
                            otherBtn.classList.toggle('ik-wishlist-toggle--active', added);
                            otherBtn.setAttribute('aria-label',
                                added ? 'Rimuovi dalla wishlist' : 'Aggiungi alla wishlist'
                            );
                        }
                    });

                    // Wishlist page: rimuovi card con animazione
                    if (!added) {
                        const card = btn.closest('.ik-course-card');
                        const inWishlistPage = card && card.closest('.ik-wishlist-courses');
                        if (card && inWishlistPage) {
                            card.style.transition = 'opacity .3s, transform .3s';
                            card.style.opacity = '0';
                            card.style.transform = 'scale(0.95)';
                            setTimeout(() => card.remove(), 300);
                        }
                    }

                    // Toast notification
                    window.dispatchEvent(new CustomEvent(
                        added ? 'wishlist-item-added' : 'wishlist-item-removed'
                    ));
                });
            });
        },
    }));
}
